
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.008 17.696c-2.125-2.137-2.144-5.597-.042-7.712a5.33 5.33 0 013.795-1.574c1.397 0 2.801.54 3.872 1.616 2.125 2.137 2.144 5.597.042 7.711s-5.542 2.096-7.667-.041zm14.779 6.091l-5.685-5.537c2.202-2.684 2.04-6.691-.477-9.222-2.673-2.688-7.001-2.706-9.65-.042s-2.631 7.019.041 9.708a6.842 6.842 0 004.864 2.028 6.73 6.73 0 004.221-1.482l5.71 5.56a.697.697 0 00.991-.015.709.709 0 00-.015-.998z"}})])
          )
        }
      }
    